import request from '@/http/axios/axios'

export function getSettings () {
  return request({
    url: 'system-settings',
    method: 'GET',
    params: {per_page:100000}
  })
}
